import { GraphQLError } from 'graphql';

const FEDERATION_CHECKS_FAILED_ERROR = 'federation-error';
const DEFAULT_ERROR = 'invalid-type-defs';

const expectedFederationErrors = [
  /^Encountered unknown Apollo Federation directive .*?$/,
  /^typeDefs must contain `@link` schema extension to be used with Apollo Federation$/,
  /^Alias for directive .*? is not of type string$/,
];

export class SchemaValidationError extends GraphQLError {
  public readonly reason: string;

  public readonly message: string;

  constructor(message: string, reason?: string) {
    super(message);
    this.message = message;
    this.reason = reason ?? DEFAULT_ERROR;
  }
}

function formatSchemaValidationError(error: Error): SchemaValidationError {
  if (expectedFederationErrors.some((expectedErrorRegex) => expectedErrorRegex.test(error.message))) {
    return new SchemaValidationError(error.message, FEDERATION_CHECKS_FAILED_ERROR);
  }
  if (error instanceof SchemaValidationError) {
    return error;
  }
  return new SchemaValidationError(error.message);
}

export class AggregateError extends Error {
  public readonly errors: Error[];

  constructor(errors: Error[]) {
    super('');
    this.errors = errors.map(formatSchemaValidationError);
  }
}
